module.exports = __webpack_public_path__ + "img/kermel.91922a9d.jpg";